export const SDK_VERSION = '7.74.0';
